import logo from '@/assets/login-logo.png';
import { Typography } from '@mui/material';
import { loginHeroDescription, loginHeroTitle } from './style';

export const LoginFormHeroSection = () => {
  return (
    <>
      <img src={logo} />
      <Typography variant="h1" sx={loginHeroTitle}>
        Your AI assistant for
        <br /> medical
        <br /> documentation.
      </Typography>
      <Typography variant="body1" sx={loginHeroDescription}>
        Log in to streamline your clinical workflow.
      </Typography>
    </>
  );
};
